export const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_prayer-group-hub/artifacts/v3qzxqsr_LOGO%20JJU%20CLUB.png";
